import axios from "axios";
import {BaseResponse} from "../../BaseResponse";

export async function deleteCertificate(uid: string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/tank/certificate/${uid}`)

    return response.data
}
